import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Undo16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.22222 1.09735C2.62109 1.09735 2.94444 1.43314 2.94444 1.84735V3.75899C4.14057 2.11507 5.99617 1.09735 8.05114 1.09735C11.6483 1.09735 14.5 4.25222 14.5 8.02735C14.5 11.8201 11.5807 14.9027 8.00001 14.9027C7.60114 14.9027 7.27779 14.5669 7.27779 14.1527C7.27779 13.7384 7.60114 13.4027 8.00001 13.4027C10.7595 13.4027 13.0556 11.0162 13.0556 8.02735C13.0556 5.02089 10.7942 2.59735 8.05114 2.59735C6.26451 2.59735 4.65315 3.59702 3.75284 5.19912H6.05702C6.45589 5.19912 6.77924 5.53491 6.77924 5.94912C6.77924 6.36333 6.45589 6.69912 6.05702 6.69912H2.22222C1.82335 6.69912 1.5 6.36333 1.5 5.94912V1.84735C1.5 1.43314 1.82335 1.09735 2.22222 1.09735Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
